import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

interface FilterBoxBarProps {
	onOpenDrawer: (event: React.KeyboardEvent | React.MouseEvent) => void;
	isLoading?: boolean;
}

const FilterBoxBar = ({ onOpenDrawer, isLoading = false }: FilterBoxBarProps) => {
	const handleClick = (event: React.KeyboardEvent | React.MouseEvent) => {
		if (!isLoading) {
			onOpenDrawer(event);
		}
	};

	return (
		<div className="filter-box-bar">
			<div className="filter-box-left">
				<Typography variant="h6">Global Filters</Typography>
			</div>
			<div className="filter-box-right">
				<Tooltip title={isLoading ? 'Loading filter data...' : ''} disableInteractive>
					<span>
						<Button onClick={handleClick} disabled={isLoading}>
							<FilterAltOutlinedIcon style={{ marginRight: '5px' }} />
							<span>Filters</span>
						</Button>
					</span>
				</Tooltip>
			</div>
		</div>
	);
};

export default FilterBoxBar;
